import { CallMethodEnums } from '@/types/api';
import {
  CreateApiKeyReq,
  CreateApiKeyRes,
  DeleteApiKeyRes,
  DisableApiKeyRes,
  EnableApiKeyRes,
  GetApiKeyRes,
  GetApiKeysRes
} from '@/types/apiKey';

import { call } from './utils';

export const apiKeyCreate = async( name: string, expiresAt?: string | null ): Promise<CreateApiKeyRes> => {
  const json = call<CreateApiKeyReq, CreateApiKeyRes>( {
    body: {
      name,
      expires_at: expiresAt // null = no expiration
    },
    isProtected: true,
    method: CallMethodEnums.POST,
    route: '/api/api_keys'
  } );

  return json;
};

export const apiKeyDelete = async( keyId: string ): Promise<DeleteApiKeyRes> => {
  const json = call<undefined, DeleteApiKeyRes>( {
    isProtected: true,
    method: CallMethodEnums.DELETE,
    route: '/api/api_keys/' + keyId
  } );

  return json;
};

export const apiKeysGet = async(): Promise<GetApiKeysRes> => {
  const json = call<unknown, GetApiKeysRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: '/api/api_keys'
  } );

  return json;
};

export const apiKeyGet = async( keyId: string ): Promise<GetApiKeyRes> => {
  const json = call<undefined, GetApiKeyRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: '/api/api_keys/' + keyId
  } );

  return json;
};

export const apiKeyDisable = async( keyId: string ): Promise<DisableApiKeyRes> => {
  const json = call<undefined, DisableApiKeyRes>( {
    isProtected: true,
    method: CallMethodEnums.PUT,
    route: '/api/api_keys/' + keyId + '/disable'
  } );

  return json;
};

export const apiKeyEnable = async( keyId: string ): Promise<EnableApiKeyRes> => {
  const json = call<undefined, EnableApiKeyRes>( {
    isProtected: true,
    method: CallMethodEnums.PUT,
    route: '/api/api_keys/' + keyId + '/enable'
  } );

  return json;
};


// endpoints for API key scoping are not implemented yet
const notImplemented = ( name: string ): never => {
  throw new Error(
    `${ name }: is not implemented yet.`
  );
};

export const apiKeyCreateScoped = async( _req: CreateApiKeyReq ): Promise<CreateApiKeyRes> => {
  return notImplemented( 'apiKeyCreateScoped' );
};

export const apiKeysGetScoped = async(): Promise<GetApiKeysRes> => {
  return notImplemented( 'apiKeysGetScoped' );
};

export const apiKeyDeleteScoped = async( _keyId: string ): Promise<DeleteApiKeyRes> => {
  return notImplemented( 'apiKeyDeleteScoped' );
};

export const apiKeyEnableScoped = async( _keyId: string ): Promise<EnableApiKeyRes> => {
  return notImplemented( 'apiKeyEnableScoped' );
};

export const apiKeyDisableScoped = async( _keyId: string ): Promise<DisableApiKeyRes> => {
  return notImplemented( 'apiKeyDisableScoped' );
};
